module.exports = __webpack_public_path__ + "static/media/customizacion.36bc3259.png";